import './styles/SubtleActionButton.scss';

import { Fab } from '@mui/material';

import clsx from 'clsx';
import { FunctionComponent, MouseEventHandler, ReactNode } from 'react';

import SubmittingLoader from '../Util/SubmittingLoader';

type ActionTypes = 'positive' | 'negative' | 'default' | 'neutral' | 'primary';

interface Props {
  icon: React.ElementType;
  type?: ActionTypes;
  onClick?: MouseEventHandler;
  slide?: boolean;
  submit?: boolean;
  disabled?: boolean;
  loading?: boolean;
  children?: ReactNode;
}

export const SubtleActionButton: FunctionComponent<Props> = props => {
  return (
    <Fab
      size="small"
      className={clsx('subtle-action-button', {
        [`subtle-action-button__default`]: !props.type,
        [`subtle-action-button__${props.type}`]: props.type
      })}
      variant={props.children ? 'extended' : 'circular'}
      onClick={props.onClick}
      type={props.submit ? 'submit' : 'button'}
      disabled={props.disabled}
    >
      <props.icon
        className={clsx('subtle-action-button__icon', {
          'subtle-action-button__icon--with-text': !!props.children
        })}
      />
      {props.children ? (
        <span
          className={clsx('subtle-action-button__text', {
            'subtle-action-button__text--slide': props.slide
          })}
        >
          {props.children}
        </span>
      ) : null}
      {props.loading && <SubmittingLoader size={30} />}
    </Fab>
  );
};
